import { AnnotationComponent } from './shared/components/photoeditor/annotation/annotation/annotation.component';
import { AnnotationLayerComponent } from './shared/components/photoeditor/annotation/annotation/annotation-layer.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { LoginPageComponent } from './auth/pages/login/index';
import { HomeComponent } from './home/home.component';
import { AdminHomeComponent } from './home/admin-home.component';
import { AuthGuard } from './auth/guards/index';
import { environment } from '../environments/environment';
import { ChangePasswordPageComponent } from './changePassword/change-password.page';
import { PartsMessageComponent } from './shared/pages/parts-message/parts-message.component';
import { UnauthorizedComponent } from './shared/pages/unathorized/unauthorized.component';
import { PermissionGuard } from './utils/permission.guard';
import { CurrentUserResolver } from './utils/currentPerson.resolver';
import { TranslateResolver } from './utils/translate.resolver';
import { CurrencyResolver } from './utils/currency.resolver';
import { SynchronizationResolver } from './utils/syncronization.resolver';

const appRoute = environment.applicationRoute;

const appRoutes: Routes = [
  { path: '', redirectTo: appRoute, pathMatch: 'full' },
  {
    path: appRoute,
    canActivate: [AuthGuard, PermissionGuard],
    resolve: { synchronizeData: SynchronizationResolver },
    component: HomeComponent
  },
  {
    path: `${appRoute}/admin`,
    canActivate: [AuthGuard, PermissionGuard],
    resolve: { currentPerson: CurrentUserResolver },
    data: { permission: 'manage.template' },
    component: AdminHomeComponent
  },
  { path: `${appRoute}/parts`, resolve: { currentPerson: CurrentUserResolver }, component: PartsMessageComponent },
  { path: `${appRoute}/test`, resolve: { currentPerson: CurrentUserResolver }, component: AnnotationLayerComponent },
  { path: appRoute + '/login', resolve: { translation: TranslateResolver }, component: LoginPageComponent },
  { path: appRoute + '/changePassword', component: ChangePasswordPageComponent },
  {
    path: appRoute + '/unauthorized',
    resolve: { currentPerson: CurrentUserResolver },
    component: UnauthorizedComponent
  },
  { path: appRoute + '/*', redirectTo: appRoute, pathMatch: 'full' },
  { path: '*', redirectTo: appRoute }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [PermissionGuard, CurrentUserResolver, TranslateResolver, CurrencyResolver]
})
export class AppRoutingModule {}
